<div class="flex flex-col max-w-240 md:min-w-200 max-h-screen -m-6">

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{dialogTitle}}</div>
        <button mat-icon-button (click)="onClose()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>

    <form class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto" [formGroup]="statusChangeForm">
        <fuse-alert [appearance]="'soft'" *ngIf="alert" [dismissible]="true" [dismissed]="false" [type]="alert.type">
            {{alert.message}}
        </fuse-alert>

        <!-- <mat-form-field class="w-1/2 pr-2" appearance="outline">
            <mat-label>Out Date</mat-label>
            <input matInput [matDatepicker]="outDatePicker" [formControlName]="'outDate'" [placeholder]="'Out Date'">
            <mat-datepicker-toggle matSuffix [for]="outDatePicker">
            </mat-datepicker-toggle>
            <mat-datepicker #outDatePicker></mat-datepicker>
        </mat-form-field> -->
        <mat-form-field appearance="outline">
            <mat-label>Status </mat-label>
            <input type="text" matInput [formControl]="statusChangeForm.get('inwardStatus')"
                [matAutocomplete]="autoStatus">
            <mat-autocomplete #autoStatus="matAutocomplete" [displayWith]="displayStatusFn()">
                <mat-option *ngFor="let inwardStatus of inwardStatuses" [value]="inwardStatus">
                    {{InwardStatusData[inwardStatus]}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Status Holder</mat-label>
            <mat-select placeholder="Search Status Holder" [formControlName]="'assignEmployeeId'">
                <input (keyup)="onUserSearch($event.target.value)" class="py-3 p-2 w-full"
                    placeholder="Search Status Holder">
                <mat-option>None</mat-option>
                <mat-option *ngFor="let option of filterUsers" [value]="option.id">
                    {{ option.name }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="statusChangeForm.get('assignEmployeeId').hasError('required')">
                Status Holder
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Note</mat-label>
            <input matInput [formControlName]="'note'">
        </mat-form-field>

        <!-- <div class="flex">
            <mat-slide-toggle [formControlName]="'isActive'" [color]="'primary'">
                {{statusChangeForm.get('isActive').value === true ? 'Active' : 'Disabled'}}
            </mat-slide-toggle>
        </div> -->

        <!-- Actions -->
        <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4 sm:mt-6">
            <div class="-ml-2">

            </div>

            <div class="flex items-center mt-4 sm:mt-0">
                <!-- Discard -->
                <!-- <button class="order-first sm:order-last" *ngIf="statusChange && statusChange.id > 0" mat-flat-button
                    [color]="'primary'" (click)="updateAndClose()">
                    Update
                </button> -->
                <button class="order-first sm:order-last" *ngIf="!statusChange" mat-flat-button [color]="'primary'"
                    (click)="saveAndClose()" [disabled]="!statusChangeForm.valid">
                    Save
                </button>
            </div>
        </div>
    </form>
</div>